import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const uploadImage = async (selectedDomain: string, image: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'shop-profile-image',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            image,
        }
    });
}